// Exports all the firebase components allow us to just need to import this file not each one individually 
import FirebaseContext, { withFirebase } from './context'
import {Firebase, AUTH_LEVEL} from './firebase'
 
export default Firebase
  
export { FirebaseContext, withFirebase, AUTH_LEVEL}
 